<template>
  <div>
    <v-dialog v-model="messagesDialogEnabled" max-width="1000px">
      <messagesDialog
        :messages="this.selected"
        @close-messages="messagesClosed"
        @save-messages="messagesSaved"
      ></messagesDialog>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="1000px" persistent>
      <div>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="editedItem.key" label="Key" :counter="250" required></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="editedItem.locale" label="Locale" :counter="2" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.message"
                    label="Message"
                    :counter="250"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="error" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            <v-btn color="blue darken-1" text @click="dialog = true">Save and add another</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>

    <v-card>
      <v-card-title>Messages</v-card-title>
      <v-card-text>
        <v-container>
          <v-row justify="space-between" no-gutters>
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-col>
            <div class="flex-grow-1"></div>
            <v-col cols="2" align-self="end">
              <v-btn color="primary" @click="editItem(defaultItem)">New Message</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="userMessages"
      :search="search"
      class="elevation-1"
      item-key="key + locale"
      group-by="key"
    >
      <template v-slot:group.header="{ items }">
        <td>
          {{ items[0].key }}
          <v-icon small right @click="selectGroup(items)">edit</v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from 'moment'
import messagesDialog from '@/components/MessagesDialog.vue'
let rh = require('@/components/APIs/RequestHandler')
export default {
  props: ['auth'],
  data: () => ({
    model: null,
    loadingUsers: false,
    search: '',
    expanded: [],
    singleExpand: false,
    rppItems: [
      60,
      90,
      120,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 30,
    selected: [],
    groupBySync: [],
    dialog: false,
    messagesDialogEnabled: false,
    editMessage: false,
    // loginHistoryModel: false,
    headers: [
      {
        text: 'key',
        align: 'left',
        sortable: true,
        value: 'key',
        width: '30%'
      },
      { text: 'locale', value: 'locale', sortable: true, width: '10%' },
      { text: 'Message', value: 'message' }
    ],
    userMessages: [],
    locales: [
      { text: 'FR', value: 'FR' },
      { text: 'EN', value: 'EN' },
      { text: 'ES', value: 'ES' },
      { text: 'CS', value: 'CS' },
      { text: 'EL', value: 'EL' }
    ],
    editedIndex: -1,
    editedItem: {
      key: '',
      locale: '',
      message: '',
      end: ''
    },
    defaultItem: {
      key: '',
      locale: '',
      message: '',
      end: ''
    },
    localeType: { text: 'EN', value: 'EN' }
  }),
  components: {
    messagesDialog
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add new message' : 'Edit Item'
    },
    filteredItems () {
      return this.locale.filter(i => {
        return !this.localeType || i.type === this.localeType
      })
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    async initialize () {
      this.loadingUsers = true
      this.userSearchPanelModel = 0
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_MESSAGE}/messages`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.userMessages = getResponse.data
      this.loadingUsers = false
    },
    async selectMessage (a) {
      this.selected = [a]
      this.dialog = true
    },
    selectGroup (item) {
      this.selected = item
      this.messagesDialogEnabled = true
    },
    editItem (item) {
      // console.log(JSON.stringify(item))
      this.editedIndex = this.userMessages.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    logLocale () {
      // console.log('Logging: ', this.localeType.value)
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    async save () {
      if (this.editedIndex > -1) {
        Object.assign(this.userMessages[this.editedIndex], this.editedItem)
      } else {
        this.userMessages.push(this.editedItem)
      }
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_MESSAGE}/messages`
      var getResponse = await rh.default
        .post(endpoint, '[' + JSON.stringify(this.editedItem) + ']', true)
        .catch(e => {
          this.errors.push(e)
        })
      // console.log(JSON.stringify(userMessages))
      this.close()
    },
    messagesClosed () {

    },
    messagesSaved () {

    }
  }
}
</script>
<style>
</style>
